module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-print-cue-list",
    attrs: {
      "md-column": ""
    }
  }, [(!_vm.globalCues.length) ? _c('p', {
    staticClass: "md-body-2"
  }, [_vm._v("You haven't created any cues on this page. Double click to add cues and right click to add notes.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cues), function(cue, index) {
    return _c('project-cues-cue', {
      key: cue.id,
      class: _vm.cuePlacementclass(cue),
      attrs: {
        "cue": cue,
        "open": _vm.isOpen(cue),
        "locked": _vm.locked,
        "totalPages": _vm.totalPages,
        "selectedScale": _vm.selectedScale,
        "cuesListWidth": _vm.cuesListWidth,
        "svgContentWidth": _vm.svgContentWidth,
        "cueIndex": index,
        "landscape": _vm.landscape,
        "currentPage": _vm.currentPage,
        "openCues": _vm.openCues
      },
      on: {
        "openCue": function($event) {
          return _vm.openCue(cue)
        },
        "closeCue": function($event) {
          return _vm.closeCue(cue)
        },
        "destroy": _vm.destroy,
        "updatedCue": _vm.updatedCue
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c419dd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/cue-list.vue
// module id = 1225
// module chunks = 21